<app-menu></app-menu>
<div class="formulario-container">
	<div class="titulo">
		<h1>Formulário de compromisso</h1>
	</div>
	<form action="">
		<div class="formulario">
			<div class="izquierda">
				<label for="especialidad">Especialidade*</label>
				<mat-form-field >
					<mat-label>Estado</mat-label>
					<mat-select name="select" [(ngModel)]="especialidad">
						<mat-option [value]="0">None</mat-option>
						<mat-option *ngFor="let especialidad of especialidades; let indices = index" [value]="indices+1" >{{especialidad}}</mat-option>
					</mat-select>
				</mat-form-field>
				<label for="historial">Histórico médico</label>
				<input type="file" name="historial" id="">
				<label for="dolor">Alergia a medicação ou tratamento?</label>
				<input type="text" name="dolor" id="" required [(ngModel)]="alergia">
				<label for="fecha">Atualmente você toma algum medicamento?</label>
				<input type="text" name="fecha" id="" autocomplete="off" required [(ngModel)]="medicamento">
				<label for="especialidad">Deseja receber sua receita por correio?</label>
				<mat-form-field >
					<mat-label>Estado</mat-label>
					<mat-select name="email" [(ngModel)]="emailN">
						<mat-option [value]="0">Sim</mat-option>
						<mat-option [value]="1">Não</mat-option>
					</mat-select>
				</mat-form-field>

			</div>
			<div class="derecha">
				<div class="sintomas">
					<h2>Sintomas (Max. 5)</h2>
					<div class="sintomas-container" #sintomasContainer>
						<input type="text" name="sintomas" id="" autocomplete="off" *ngIf = "0<sintomasLength" class="sintoma">
						<fa-icon [icon]="faTrash"*ngIf = "0<sintomasLength"></fa-icon>

						<input type="text" name="sintomas" id="" autocomplete="off" *ngIf = "1<sintomasLength" class="sintoma">
						<fa-icon [icon]="faTrash"*ngIf = "1<sintomasLength"></fa-icon>

						<input type="text" name="sintomas" id="" autocomplete="off" *ngIf = "2<sintomasLength" class="sintoma">
						<fa-icon [icon]="faTrash"*ngIf = "2<sintomasLength"></fa-icon>

						<input type="text" name="sintomas" id="" autocomplete="off" *ngIf = "3<sintomasLength" class="sintoma">
						<fa-icon [icon]="faTrash"*ngIf = "3<sintomasLength"></fa-icon>
						
						<input type="text" name="sintomas" id="" autocomplete="off" *ngIf = "4<sintomasLength" class="sintoma">
						<fa-icon [icon]="faTrash"*ngIf = "4<sintomasLength"></fa-icon>
					</div>
					<div class="anadirSintoma" #anadirSintoma (click)="sumarSintoma()" *ngIf= " 5>sintomasLength">
							<fa-icon [icon]="faPlusCircle"></fa-icon>
					</div>
				</div>
				<div class="descripcion">
					<h2>Descrição</h2>
					<textarea name="" id="" cols="30" rows="10"></textarea>
				</div>
			</div>
		</div>
		<button type="submit" (click)="generarConsulta()">Enviar</button>
	</form>
</div>